module.exports = __webpack_public_path__ + "static/3-eeb3614fc73ee40248cf2756783c4dc1.png";